import clsxm from "@/lib/clsxm";
import {createCampaignForCompanyAtom} from "@/store/jotaiAtoms";
import {useSetAtom} from "jotai";
import {useRef, useState, type FC, type SVGProps} from "react";
import {useHoverDirty} from "react-use";

const CampaignTile: FC<{
  chipTitle?: string;
  description: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
  onClick?: () => void;
  title: string;
}> = ({chipTitle, description, Icon, onClick, title}) => {
  const tileRef = useRef<HTMLDivElement>(null!);
  const isHovering = useHoverDirty(tileRef);
  const [isClicked, setClicked] = useState(false);
  const setCreateCampaignForCompany = useSetAtom(createCampaignForCompanyAtom);

  return (
    <div
      ref={tileRef}
      className="relative overflow-visible"
      onMouseMove={e => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        e.currentTarget.style.setProperty("--mouse-x", `${x}px`);
        e.currentTarget.style.setProperty("--mouse-y", `${y}px`);
      }}
      onMouseLeave={e => {
        e.currentTarget.style.removeProperty("--mouse-x");
        e.currentTarget.style.removeProperty("--mouse-y");
      }}>
      <div className="relative overflow-hidden">
        <div
          onMouseDown={() => {
            setClicked(true);
            setTimeout(() => setClicked(false), 600);
          }}
          className="border-primary-light-solid hover:border-ai-purple flex shrink-0 grow cursor-pointer flex-col items-center justify-center rounded-md border transition-all duration-150 lg:h-30 lg:max-w-100"
          onClick={() => {
            onClick?.();
            setCreateCampaignForCompany(null);
          }}>
          {isClicked && (
            <div className="animate-ripple bg-primary-powder absolute h-full w-full -translate-x-1/2 -translate-y-1/2 opacity-30" />
          )}
          <div className="flex items-center justify-center gap-3 p-5">
            <Icon
              className={clsxm(
                "size-10 shrink-0 transition-all duration-150",
                isHovering ? "text-ai-purple" : "text-primary-light-solid",
              )}
            />
            <div className="flex flex-col gap-1">
              <span className="text-neutral-black text-start text-xl font-semibold">{title}</span>
              <span className="text-neutral-grey-dark text-start text-xs">{description}</span>
            </div>
          </div>
        </div>
      </div>
      {chipTitle && (
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <span className="text-2xs min-h-5 rounded-full bg-linear-(--ai-purple-gradient) px-5 py-1 font-semibold text-white shadow-sm">
            {chipTitle}
          </span>
        </div>
      )}
    </div>
  );
};

export default CampaignTile;
